export default "__VITE_ASSET__9afd4daa__"